<div class="col-12">
  <div
    class="d-flex justify-content-center align-items-center"
    style="border-radius: 41px"
  >
    <a
      type="button"
      class="btn-custom-dark btn rounded-pill w-100 px-4"
      [href]="calendarUrl"
      target="_blank"
    >
      <img
        [src]="actionImg"
        class="img-fluid cl"
        style="cursor: pointer; height: 22px; margin-bottom: 2px;"
        alt=""
      />
      <span class="py-2 px-2"> Add to calendar </span>
    </a>
  </div>
</div>
